import axios from '../../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/inquiry/AInquiryRuleSetting/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/inquiry/AInquiryRuleSetting/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/inquiry/AInquiryRuleSetting/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/inquiry/AInquiryRuleSetting/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/inquiry/AInquiryRuleSetting/delete",{
        params: {
            ids:params
        }
    } )
}
function GET_FORM_LIST(params) {
    return  axios.post("/inquiry/AInquiryRuleSetting/add",{...params} )
}

export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,GET_FORM_LIST
};
